type QuotationMarkProps = {
  className?: string;
};

export const QuotationMark = ({ className }: QuotationMarkProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="27"
    viewBox="0 0 32 27"
    fill="none"
    className={className}
  >
    <path
      d="M31.7271 1.2335C27.6343 3.01523 22.0408 7.67513 21.768 14.3909C22.8594 13.7056 24.0872 13.4315 25.3151 13.4315C29.135 13.4315 32 16.3096 32 20.1472C32 24.1218 29.135 27 25.1787 27C20.2673 27 17.5388 23.2995 17.5388 17.8173C17.5388 8.49746 22.8594 2.46701 31.1814 0L31.7271 1.2335ZM0 17.8173C0 8.49746 5.32064 2.46701 13.6427 0L14.1884 1.2335C10.0956 3.01523 4.50208 7.67513 4.22923 14.3909C5.32064 13.7056 6.54848 13.4315 7.77632 13.4315C11.5963 13.4315 14.4612 16.3096 14.4612 20.1472C14.4612 24.1218 11.5963 27 7.6399 27C2.72854 27 0 23.2995 0 17.8173Z"
      fill="#1C7B7C"
    />
  </svg>
);
